<template>
  <button
    :disabled="status == 'Already Connected' || status == 'Pending'"
    class="storefront-btn-blue ml-0 lg:ml-12 mr-4 lg:mr-0"
    type="button"
    @click="handleConnectClick"
  >
    <svg-vue 
      icon="user-plus-solid" 
      class="h-4 lg:h-5 inline-block mr-3" 
      :class="status == 'Already Connected' || status == 'Pending' ? 'fill-black' : 'fill-white'"
    />
    <span class="inline-block">{{ status }}</span>
    <svg-vue v-if="saving" icon="spinner" class="fill-white animate-spin h-4 lg:h-5 inline-block ml-3" />
  </button>
</template>

<script>
export default {
    props: ['status', 'saving'],
    methods: {
        handleConnectClick() {
            this.$emit('connect')
        },
    },
};
</script>